export default function RealTime({ color }: { color: string; }) {
  return (
    <svg width='24' height='24' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4V19.9992H19.9992M7.99981 13.9996L11.4996 10.4998L13.9995 12.9997L19.4993 7.49994M15.7576 6.99986H20V11.2423" stroke={color} strokeOpacity='1' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}